export default "__VITE_ASSET__D9E9jYms__"